import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline';
import Send from '@mui/icons-material/Send';
import { Button, CircularProgress, Typography } from '@mui/material';
import clsx from 'clsx';

type FeedbackDialogActionsProps = {
    className?: string;
    disableForm?: boolean;
    isSendFeedbackSuccess: boolean;
    isSendFeedbackLoading: boolean;
    isValid: boolean;
    submitForm: () => void;
};

const FeedbackDialogActions = ({
    className,
    disableForm = false,
    isSendFeedbackSuccess,
    isSendFeedbackLoading,
    isValid,
    submitForm,
}: FeedbackDialogActionsProps) => (
    <div className={clsx('w-full flex flex-col md:flex-row md:justify-between md:items-end md:gap-4', className)}>
        <div>
            {isSendFeedbackSuccess && !isSendFeedbackLoading && (
                <div className="flex gap-3 rounded-md bg-caribbean-green px-4 py-3 mb-4 md:mb-0">
                    <CheckCircleOutline color="white" />
                    <Typography variant="body1" fontWeight={600} className="text-white">
                        Feedback Sent Successfuly!
                    </Typography>
                </div>
            )}
        </div>
        <div className="w-full md:w-auto">
            <Button
                disabled={disableForm || !isValid || isSendFeedbackSuccess}
                startIcon={!isSendFeedbackLoading ? <Send /> : <CircularProgress color="white" size={24} />}
                size="large"
                disableElevation={false}
                className="rounded-sm"
                type="submit"
                onClick={submitForm}
                fullWidth
            >
                {!isSendFeedbackLoading && <Typography>Submit Feedback</Typography>}
            </Button>
        </div>
    </div>
);

export { FeedbackDialogActions };
